const Style = `
  <style>
    .product-extra-details {
      padding: 0 12px 20px 12px;
    }

    .product-extra-details .navigation-wrapper {
      display: none;
    }

    .product-extra-details .accordion-container.details-container .system {
      border-top: none;
      border-bottom: 1px solid #d2eae5;
    }

    .product-extra-details .accordion-container.details-container .system .system-title {
      line-height: 28px !important;
      padding: 29px 12px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      position: relative;
    }

    .product-extra-details .accordion-container.details-container .system .system-title::after {
      content: "\\f078";
      color: #3a3e43;
      font-size: 21px;
      position: relative;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner {
      padding: 0 0 24px 0;
    }

    @media (max-width: 767px) {
      .product-extra-details .accordion-container.details-container .system .system-content .content-inner .image-bestseller-container {
        overflow: auto;
      }
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .image-container {
      margin-bottom: 16px;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .image-container .slick-slide {
      margin: 0 5px;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .image-container .slick-slide > div {
      display: flex;
      width: fit-content;
      margin: 0 auto 0 0;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .image-container img {
      aspect-ratio: 0.95;
      object-fit: cover;
      border-radius: 11px;
      max-height: 685px;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .image-container .video-wrapper {
      position: relative;
      display: flex;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .image-container .video-wrapper video {
      aspect-ratio: 0.95;
      object-fit: cover;
      border-radius: 11px;
      max-height: 685px;
      position: relative;
      visibility: visible !important;
      opacity: 1 !important;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .text-image-content {
      padding: 0 12px;
      display: flex;
      flex-direction: column;
      gap: 18px;
      max-width: 655px;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .block {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .block img {
      width: 114px;
      height: 114px;
      object-fit: cover;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .block.faqs .text-only {
      gap: 4px;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .block.faqs .headline {
      font-size: 1.25rem;
      font-weight: bold;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .block.faqs .cta {
      max-width: 300px;
    }

    .product-extra-details .accordion-container.details-container .system .system-content .content-inner .text-only {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .product-extra-details .accordion-container.details-container .system.active .system-title::after {
      transform: rotateX(180deg);
    }

    .product-extra-details .accordion-container.details-container .system.active .system-content .content-inner {
      margin-top: -12px;
    }

    .product-extra-details .accordion-container.details-container .system:first-child .system-title {
      padding-top: 13px;
    }

  </style>
`;

export default Style;
